import { render, staticRenderFns } from "./JoszakiMarkdownTextBlock.vue?vue&type=template&id=f784ff58"
import script from "./JoszakiMarkdownTextBlock.vue?vue&type=script&lang=js"
export * from "./JoszakiMarkdownTextBlock.vue?vue&type=script&lang=js"
import style0 from "./JoszakiMarkdownTextBlock.vue?vue&type=style&index=0&id=f784ff58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports